export const conditionTargetInElement = (e, element, devicePixelRatio = 1) => {
  return (
    e.clientY * devicePixelRatio > element.getBoundingClientRect().top &&
    e.clientY * devicePixelRatio < element.getBoundingClientRect().bottom &&
    e.clientX * devicePixelRatio > element.getBoundingClientRect().left &&
    e.clientX * devicePixelRatio < element.getBoundingClientRect().right
  )
}

export const getLayoutData = (parentEl) => {
  const result = []

  Array.from(parentEl.children).forEach((child) => {
    result.push({
      type: child.getAttribute('type'),
      id: child.id,
      label: child.getAttribute('label'),
    })
  })

  return result
}
